import { GameCssStyles } from '../GameCssStyles'
import {
    Box,
    TextField,
    IconButton,
    MenuItem,
    Typography,
    Switch,
    Grid,
    Button
} from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { useState } from 'react';
import { CONTEST_TYPE, GAME_TYPE } from '../GameConstant';

const defaultRule = {
    ticketPrice: {
        money: { value: 0, currency: 'inr' },
        rapCoin: 0,
    },
    win: {
        prizePoolShare: 1,
        winPositions: [{ position: 1, share: 0 }],
    },
    contestType: 'Paid',
    isPromoted: false,
    ruleId: '',
    maxSpots: 2,
    minSpots: 1,
    lobbyTime: 0,
};

const defaultFanstasyRule = {
    ticketPrice: {
        money: { value: 0, currency: 'inr' },
        rapCoin: 0,
    },
    win: {
        prizePoolShare: 1,
        winPositions: [{ position: 1, share: 0 }],
    },
    contestType: 'Paid',
    isPromoted: false,
    ruleId: '',
    fantasyPickCount: 0,
    maxSpots: 2,
    minSpots: 1,
    lobbyTime: 0,
};


const StandardForkContestRules = ({ formGameData, setFormGameData, handleChange }) => {

    const [shareErrors, setShareErrors] = useState({});
    const forkContestRules = formGameData?.forkContestRules || [];
    const contestType = formGameData?.type;

    const handleChangeLocal = (index, fieldPath, value) => {
        const updated = [...forkContestRules];
        const keys = fieldPath.split('.');
        let obj = updated[index];

        for (let i = 0; i < keys.length - 1; i++) {
            if (!obj[keys[i]]) obj[keys[i]] = {};
            obj = obj[keys[i]];
        }

        obj[keys[keys.length - 1]] = value;

        setFormGameData(prev => ({
            ...prev,
            forkContestRules: updated
        }));
    };

    const getDefaultRules = () => {
        if (contestType === GAME_TYPE.PREDICT_BASED) {
            return defaultRule;
        }
        else if (contestType === GAME_TYPE.FANTASY_LEAGUE_GAME) {
            return defaultFanstasyRule;
        }
        else {
            return defaultRule;
        }
    }

    const addRule = () => {
        handleChange('forkContestRules', [...forkContestRules, JSON.parse(JSON.stringify(getDefaultRules()))]);
    }

    const removeRule = (index) => {
        const updated = [...forkContestRules];
        updated.splice(index, 1);
        setFormGameData(prev => ({
            ...prev,
            forkContestRules: updated
        }));
    };

    // Converts percentage number (e.g. 10) to decimal (e.g. 0.1)
    const convertInDecimal = (percentage) => {
        if (typeof percentage !== 'number') return 0;
        const result = parseFloat(percentage / 100).toFixed(4);
        console.log("result : ", result);
        return result;
    };

    // Converts decimal (e.g. 0.1) to percentage (e.g. 10)
    const convertInPercentage = (decimal) => {
        return typeof decimal === 'number' ? Math.round(decimal * 100) : '';
    };

    const addWinPosition = (ruleIndex) => {
        const updated = [...forkContestRules];
        const rule = updated[ruleIndex];
        const maxSpots = rule.maxSpots;
        const currentTotalShare = rule.win.winPositions.reduce((sum, pos) => sum + (pos.share || 0), 0);

        console.log("currentTotalShare : ", currentTotalShare)
        if (currentTotalShare >= 1) {
            alert("Total share should not exceed 100%");
            return;
        }

        const nextPosition = rule.win.winPositions.length + 1;
        const remainingShare = parseFloat((1 - currentTotalShare).toFixed(4)); // store as float

        console.log("maxSpots : ",maxSpots)
        console.log("nextPosition : ",nextPosition)
        if (nextPosition > maxSpots) {
            alert("Increase max spot value to add more win positions.");
        }
        else {
            console.log("remainingShare : ", remainingShare)
            rule.win.winPositions.push({
                position: nextPosition,
                //share: remainingShare, // set to remaining
                share: 0,
            });

            setFormGameData(prev => ({
                ...prev,
                forkContestRules: updated
            }));
        }
    };

    const removeWinPosition = (ruleIndex, posIndex) => {
        const updated = [...forkContestRules];
        updated[ruleIndex].win.winPositions.splice(posIndex, 1);
        setFormGameData(prev => ({
            ...prev,
            forkContestRules: updated
        }));
    };

    return (
        <Box sx={GameCssStyles.containerStyleColumn_sx}>
            <Typography variant="h6" fontWeight={600} mb={0} alignSelf={"start"} justifySelf={'start'}>Game Contest Rules</Typography>

            <Box sx={GameCssStyles.containerStyleColumnWithoutBorder_sx}>
                {forkContestRules?.map((rule, index) => (
                    <Box
                        key={index}
                        sx={{
                            border: '1px solid #ccc',
                            borderRadius: 2,
                            p: 2,
                            mb: 2,
                            background: '#f4f1f9',
                        }}
                    >
                        <Grid container spacing={2}>
                            {(
                                !contestType === GAME_TYPE.PREDICT_BASED ||
                                !contestType === GAME_TYPE.FANTASY_LEAGUE_GAME
                            ) && <Grid>
                                    <TextField
                                        fullWidth
                                        label="Lobby Time"
                                        type="number"
                                        value={rule?.lobbyTime}
                                        onChange={(e) =>
                                            handleChangeLocal(index, 'lobbyTime', parseInt(e.target.value))
                                        }
                                        sx={{ ...GameCssStyles.formSingleLineTextField_sx, width: '150px' }}
                                    />
                                </Grid>}
                            <Grid>
                                <TextField
                                    select
                                    fullWidth
                                    label="Contest Type"
                                    value={rule?.contestType ?? ''}
                                    onChange={(e) =>
                                        handleChangeLocal(index, 'contestType', e.target.value)
                                    }
                                    sx={{ ...GameCssStyles.formSingleLineTextField_sx, width: '150px', justifyContent: 'flex-start', alignContent: 'flex-start', textAlign: 'left' }}
                                >
                                    <MenuItem value="Paid">Paid</MenuItem>
                                    <MenuItem value="Practice">Practice</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid>
                                <TextField
                                    fullWidth
                                    label="Ticket Price"
                                    type="number"
                                    value={rule?.ticketPrice?.money?.value}
                                    onChange={(e) =>
                                        handleChangeLocal(index, 'ticketPrice.money.value', parseFloat(e.target.value))
                                    }
                                    sx={{ ...GameCssStyles.formSingleLineTextField_sx, width: '150px' }}
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    fullWidth
                                    label="Currency"
                                    type="text"
                                    value={rule?.ticketPrice?.money?.currency}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    // onChange={(e) =>
                                    //     handleChangeLocal(index, 'ticketPrice.money.currency', e.target.value)
                                    // }
                                    sx={{ ...GameCssStyles.formSingleLineTextField_sx, width: '100px' }}
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    fullWidth
                                    label="Min Spots"
                                    type="number"
                                    value={rule?.minSpots}
                                    onChange={(e) =>
                                        handleChangeLocal(index, 'minSpots', parseInt(e.target.value))
                                    }
                                    sx={{ ...GameCssStyles.formSingleLineTextField_sx, width: '100px' }}
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    fullWidth
                                    label="Max Spots"
                                    type="number"
                                    value={rule?.maxSpots}
                                    onChange={(e) =>
                                        handleChangeLocal(index, 'maxSpots', parseInt(e.target.value))
                                    }
                                    sx={{ ...GameCssStyles.formSingleLineTextField_sx, width: '100px' }}
                                />
                            </Grid>
                            {(
                                contestType === GAME_TYPE.FANTASY_LEAGUE_GAME
                            ) && <Grid>
                                    <TextField
                                        fullWidth
                                        label="Fantasy Pick Count"
                                        type="number"
                                        value={rule?.fantasyPickCount}
                                        onChange={(e) =>
                                            handleChangeLocal(index, 'fantasyPickCount', parseInt(e.target.value))
                                        }
                                        sx={{ ...GameCssStyles.formSingleLineTextField_sx }}
                                    />
                                </Grid>}
                            <Grid>
                                <TextField
                                    fullWidth
                                    label="Rap Coin"
                                    type="number"
                                    value={rule?.ticketPrice?.rapCoin}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    // onChange={(e) =>
                                    //     handleChangeLocal(index, 'ticketPrice.rapCoin', parseInt(e.target.value))
                                    // }
                                    sx={{ ...GameCssStyles.formSingleLineTextField_sx, width: '150px' }}
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    fullWidth
                                    label="Pool Price %"
                                    type="number"
                                    value={
                                        rule?.win?.prizePoolShare !== undefined && rule?.win?.prizePoolShare !== ''
                                            ? convertInPercentage(rule.win.prizePoolShare)
                                            : ''
                                    }
                                    onChange={(e) => {
                                        const val = e.target.value;

                                        if (val === '') {
                                            handleChangeLocal(index, 'win.prizePoolShare', '');
                                            handleChangeLocal(index, 'win.winPositions', []);
                                            return;
                                        }

                                        const parsed = parseFloat(val);
                                        if (!isNaN(parsed)) {
                                            const decimal = parseFloat((parsed / 100).toFixed(4)); // 2% → 0.02
                                            handleChangeLocal(index, 'win.prizePoolShare', decimal);
                                            handleChangeLocal(index, 'win.winPositions', []);
                                        }
                                    }}
                                    sx={{ ...GameCssStyles.formSingleLineTextField_sx, width: '150px' }}
                                />
                            </Grid>
                            <Grid>
                                <Box display="flex" alignItems="center">
                                    <Typography mr={1}>Promoted</Typography>
                                    <Switch
                                        checked={rule?.isPromoted}
                                        onChange={(e) =>
                                            handleChangeLocal(index, 'isPromoted', e.target.checked)
                                        }
                                        sx={GameCssStyles.switchStyle_sx}
                                    />
                                </Box>
                            </Grid>

                            {/* Win Positions */}
                            <Box sx={{ width: '100%' }}>
                                {rule?.win?.winPositions.map((pos, posIndex) => (
                                    <Grid key={posIndex}>
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            gap={2}
                                            mb={1}
                                            sx={{ flexWrap: 'wrap' }}
                                        >
                                            <TextField
                                                label={`Position ${posIndex + 1}`}
                                                type="number"
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                value={pos.position}
                                                onChange={(e) =>
                                                    handleChangeLocal(index, `win.winPositions.${posIndex}.position`, parseInt(e.target.value))
                                                }
                                                sx={GameCssStyles.formSingleLineTextField_sx}
                                            />

                                            <TextField
                                                label="Share (%)"
                                                type="number"
                                                value={convertInPercentage(pos.share)} // Display clean 2-decimal percentage
                                                onChange={(e) => {
                                                    const val = parseFloat(e.target.value);
                                                    const decimal = parseFloat((val / 100).toFixed(4));

                                                    const currentTotal = rule?.win?.winPositions?.reduce((sum, p, i) => {
                                                        if (i === posIndex) return sum; // skip current being edited
                                                        const result = sum + (parseFloat(p.share) || 0);
                                                        console.log("result1 : ", result)
                                                        return result;
                                                    }, 0);

                                                    const prizePool = parseFloat(rule.win.prizePoolShare) || 1;

                                                    const newTotal = currentTotal + decimal;
                                                    //console.log("val : ", val)
                                                    //console.log("decimal : ", decimal)
                                                    //console.log("currentTotal : ", currentTotal)

                                                    if (posIndex > 0) {
                                                        const prevShare = rule.win.winPositions[posIndex - 1]?.share || 0;
                                                        //console.log("decimal : ",decimal)
                                                        //console.log("prevShare : ",prevShare)
                                                        if (decimal > prevShare) {
                                                            setShareErrors(prev => ({
                                                                ...prev,
                                                                [`${index}_${posIndex}`]: "Each position must have a smaller share than the previous one",
                                                            }));
                                                            return;
                                                        }
                                                    }

                                                    if (newTotal > 1) {
                                                        //show error only for this index
                                                        setShareErrors(prev => ({
                                                            ...prev,
                                                            [`${index}_${posIndex}`]: "Total share exceeds 100%"
                                                        }));
                                                    } else {
                                                        // clear error if valid
                                                        setShareErrors(prev => {
                                                            const newErrors = { ...prev };
                                                            delete newErrors[`${index}_${posIndex}`];
                                                            return newErrors;
                                                        });

                                                        handleChangeLocal(index, `win.winPositions.${posIndex}.share`, decimal);
                                                    }
                                                }}
                                                error={Boolean(shareErrors[`${index}_${posIndex}`])}
                                                helperText={shareErrors[`${index}_${posIndex}`] || ""}
                                                sx={GameCssStyles.formSingleLineTextField_sx}
                                            />

                                            <IconButton
                                                onClick={() => removeWinPosition(index, posIndex)}
                                                color="error"
                                                size="small"
                                                sx={{ backgroundColor: "#bebebeff" }}
                                            >
                                                <Remove />
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                ))}

                                <Grid textAlign="left" justifyContent={"center"} alignContent={"center"}>
                                    <Button
                                        variant="contained"
                                        onClick={() => addWinPosition(index)}
                                    >
                                        + Add Win Position
                                    </Button>
                                </Grid>
                            </Box>

                            <Box width="100%" textAlign="right" mt={2}>
                                <Button
                                    variant="contained"
                                    sx={{ backgroundColor: "#f44336", color: "#fff" }}
                                    onClick={() => removeRule(index)}
                                >
                                    Remove Rule
                                </Button>
                            </Box>
                        </Grid>
                    </Box>
                ))}

                <Box textAlign="right" mt={2}>
                    <Button variant="contained" color="primary" onClick={addRule}>
                        <Add /> Add Rule
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default StandardForkContestRules
